// function animateDigit() {
// 	if ($('.indicator--animated').length) {
// 		$('.indicator--animated').find('.indicator__value')
// 			.each(function () {
// 				const $this = $(this);
// 				$this.attr('data-value', $this.text());
// 				$this.addClass('check-viewport');
// 			});
//
// 		$('.check-viewport').on('show', function (el) {
// 			const $this = $(this);
// 			const digit = Number($this.data('value'));
// 			$this
// 				.velocity({
// 					tween: 100
// 				}, {
// 					easing: 'spring',
// 					progress: function (elements, complete) {
// 						$this.text(Math.ceil(digit * complete));
// 					}
// 				});
// 		});
// 	}
// }
//
// animateDigit();



// WEBPACK FOOTER //
// ./temp/components/key-indicator/static/index.js